export enum ReceiptValidationType {
  Date = 'date',
  Amount = 'amount',
  Phone = 'phone',
  CardLastDigits = 'card_last_digits',
  StopScamDate = 'stop_scam_date',
  StopScamAmount = 'stop_scam_amount',
  StopScamValid = 'stop_scam_valid',
}
